import { render, staticRenderFns } from "./zct.vue?vue&type=template&id=387d407f"
import script from "./zct.vue?vue&type=script&lang=js"
export * from "./zct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports